import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { App } from './App';
import { UpdateBanner } from './components/UpdateBanner';
import { markTitle } from './lib/deployment';
import './styles/base.css';
import './styles/components.css';
import './styles/theme.css';

/*
 * Label the tab before anything renders.
 *
 * The badge answers "where am I" for somebody looking at the page. This
 * answers it for somebody looking at two tabs, which is the case that
 * actually goes wrong — demo and live open side by side, identical
 * favicons, identical titles.
 */
markTitle();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <UpdateBanner />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
